var _style, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsertChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C924A4;}\n\t.st1{fill:#031434;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 5.3,
    className: "st0",
    width: 11.6,
    height: 11.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,3.5H4.2c-0.9,0-1.7,0.7-1.7,1.7v11.6c0,0.9,0.8,1.7,1.7,1.7h11.7c0.9,0,1.7-0.7,1.7-1.7V5.1 C17.5,4.2,16.8,3.5,15.8,3.5z M6.7,15c-0.5,0-0.8-0.4-0.8-0.8v-4.1c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v4.1 C7.5,14.7,7.1,15,6.7,15z M10,15c-0.5,0-0.8-0.4-0.8-0.8V7.6c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v6.6 C10.8,14.7,10.5,15,10,15z M13.3,15c-0.5,0-0.8-0.4-0.8-0.8v-1.7c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v1.7 C14.2,14.7,13.8,15,13.3,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChart);
export default __webpack_public_path__ + "static/media/insert_chart.d9c5650c797df1bf847abe5bbe290892.svg";
export { ForwardRef as ReactComponent };